import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FiscalYearDto } from '../dtos/fiscal-year.model';

@Injectable()
export class FiscalYearService {
    public newFiscalYearAdded: Subject<any>;
    constructor(private apiService: ApiService,
       private router: Router) {
        this.newFiscalYearAdded = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getFiscalYear(params?: any): Observable<ApiResponse<ApiPagedResponse<FiscalYearDto>>> {
        console.log('>>getfiscal-year', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<FiscalYearDto>>('fiscal-year', params);
    }

    getFiscalYearDetails(id) {
        return this.apiService.get(`fiscal-year/edit/${id}`);
    }

    saveFiscalYear(params?: FiscalYearDto) {
        if (params.id && params.id > 0) {
            return this.apiService.put(`fiscal-year`, params);
        } else {
            return this.apiService.post(`fiscal-year`, params);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/fiscal-year.service.ts